var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-gmail-2 {\n        fill: #f4f4f4;\n      }\n\n      .cls-gmail-3 {\n        fill: #4285f4;\n      }\n\n      .cls-gmail-4 {\n        fill: #34a853;\n      }\n\n      .cls-gmail-5 {\n        fill: #ea4335;\n      }\n\n      .cls-gmail-6 {\n        fill: #fbbc04;\n      }\n\n      .cls-gmail-7 {\n        fill: #c5221f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stickers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gmail"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-gmail-2",
    cx: 667.84,
    cy: 795.02,
    rx: 49.79,
    ry: 45.41,
    transform: "translate(-178.06 192.93) rotate(-14.53)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-gmail-3",
    d: "M647.27,816.68l3.27-24.83-6.77-8.06L637.38,779l-4.14,31.4a4.42,4.42,0,0,0,3.81,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-gmail-4",
    d: "M682.32,821.3l10.23,1.34a4.42,4.42,0,0,0,5-3.8l4.13-31.41-8.41,3.45-7.64,5.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-gmail-5",
    points: "650.54 791.85 650.77 782.01 653.04 772.87 668.83 788.32 688.09 777.48 688.11 786.42 685.59 796.47 666.34 807.3 650.54 791.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-gmail-6",
    d: "M688.09,777.48l-2.5,19,16-9,.77-5.84a6.63,6.63,0,0,0-9.83-6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-gmail-7",
    d: "M637.38,779l6,5.92,7.11,7,2.5-19-3.69-3.61a6.63,6.63,0,0,0-11.21,3.87Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.78ed35c976b28c6803dff24e21cd5539.svg";
export { ForwardRef as ReactComponent };